module.exports = __webpack_public_path__ + "static/assets/4e3d3119bd51e7bd502eeb5aab645be7.svg";